import { LuMailCheck } from "react-icons/lu";

const SuccessStep = ({ onContinue }: SuccessStepProps) => (
  <div className="w-full space-y-4 text-center">
    <div className="bh-gray-7 rounded-[10px] p-4 bg-black justify-self-center">
      <LuMailCheck className="text-2xl text-center text-white" />
    </div>
    <div className="space-y-2">
      <h1 className="text-2xl font-bold text-gray-7">Email Verified!</h1>
      <p className="text-gray-6">
        Your email has been successfully verified. You can now continue using
        your account.
      </p>
    </div>
    <button
      onClick={onContinue}
      className="w-full px-4 py-2 text-white bg-gray-7 rounded-lg hover:bg-gray-6 focus:outline-none focus:ring-1 focus:ring-gray-5 focus:ring-offset-2"
    >
      Continue
    </button>
  </div>
);

export default SuccessStep;

interface SuccessStepProps {
  onContinue: () => void;
}
